// extracted by mini-css-extract-plugin
module.exports = {"option":"Option_option__2rlSB","info":"Option_info__3H9ED","control":"Option_control__314RN"};